import React from 'react';

import Styles from './TrialDiagonal.styles';

export type TrialDiagonalProps = {
  readonly isFreemium: boolean,
  readonly isFreeTrial: boolean,
}

const TrialDiagonal: React.FC<TrialDiagonalProps> = ({
  isFreemium,
  isFreeTrial,
}) => {
  if (!isFreeTrial) {
    return null;
  }

  return (
    <div
      className={`
        flex justify-center items-end text-white cursor-default absolute uppercase w-7 h-7
        ${Styles['free-trial']}
      `}
      data-qa="device-trial"
    >
      {isFreemium ? 'Free' : 'Trial'}
    </div>
  );
};

export default TrialDiagonal;
